import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity, IndicatorGroup } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { omit } from 'lodash';
import { indicatorHasValue, useIndicatorLayouts } from '@shapeable/ui';
import { IndicatorLayoutValueLabel } from '../indicator-layouts';
import { PledgeStatusIndicatorCta } from '../elements/pledge-status-indicator-cta';

const cls = classNames('indicator-group-layout-list');

// -------- Types -------->

// -------- Props -------->

export type IndicatorGroupLayoutListFallbackProps = Classable & HasChildren & { 
  entity?: IndicatorGroup;
};

const IndicatorGroupLayoutListFallbackDefaultProps: Omit<IndicatorGroupLayoutListFallbackProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(6)};
  `,
});

const ItemsStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.UNIT(3)};
    padding: 0;
    margin: 0;
  `,
});

const ItemStyles = breakpoints({
  base: css`
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
  `,
});

const FallbackCtaStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(4)};
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Items: styled.ul`${ItemsStyles}`,
      Item: styled.li`${ItemStyles}`,

    FallbackCta: styled(PledgeStatusIndicatorCta)`${FallbackCtaStyles}`,
};

export const IndicatorGroupLayoutListFallback: Shapeable.FC<IndicatorGroupLayoutListFallbackProps> = (props) => {
  const componentProps = props;
  const { className, entity } = componentProps;
    const indicatorLayouts = useIndicatorLayouts();
  
    const indicators = entity.indicators.filter(indicatorHasValue);
    const hasIndicators = indicators.length > 0;
    // const indicatorCount = indicators.length;

    const isNotComittedIndicator = indicators.find((ind => ind.result.value === 'No'));

    const FallbackLayout = isNotComittedIndicator 
      ? (indicatorLayouts[isNotComittedIndicator.layout?.component] || IndicatorLayoutValueLabel)
      : null;
  
    return (
      <My.Container className={cls.name(className)}>
        {
          (hasIndicators && !isNotComittedIndicator) ? (
            <My.Items >
              {
                (indicators).map((indicator, index) => {
                  const Layout = indicatorLayouts[indicator.layout?.component] || IndicatorLayoutValueLabel;
                  return <My.Item key={indicator.id} >
                    <Layout 
                      key={index} 
                      entity={omit(indicator, 'flexInfo')}
                    />
                  </My.Item>
                })
              }
            </My.Items>
          ) : (
            <>
              {FallbackLayout && isNotComittedIndicator && (
                <FallbackLayout entity={omit(isNotComittedIndicator, 'flexInfo')} />
              )}
              <My.FallbackCta />
            </>
          )
        }
      </My.Container>
    )
};

IndicatorGroupLayoutListFallback.cls = cls;